import React from 'react'

import ProductTypeSelection from './ProductTypeSelection'
import ResinousApplicationSelection from './productTypes/resinous/ResinousApplicationSelection'
import ResinousSystemSelection from './productTypes/resinous/ResinousSystemSelection'
import ResinousSystemTypeSelection from './productTypes/resinous/ResinousSystemTypeSelection'
import ResinousCoverageDetails from './productTypes/resinous/ResinousCoverageDetails'
import ResinousCoveCoverageDetails from './productTypes/resinous/ResinousCoveCoverageDetails'
import ResinousQuoteCreated from './productTypes/resinous/ResinousQuoteCreated'
import ResinousCoveQuoteCreated from './productTypes/resinous/ResinousCoveQuoteCreated'
import AdhesivesProductSelection from './productTypes/adhesives/AdhesivesProductSelection'
import AdhesivesCoverageDetails from './productTypes/adhesives/AdhesivesCoverageDetails'
import AdhesivesQuoteCreated from './productTypes/adhesives/AdhesivesQuoteCreated'
import GroutProductSelection from './productTypes/grout/GroutProductSelection'
import GroutCoverageDetails from './productTypes/grout/GroutCoverageDetails'
import GroutQuoteCreated from './productTypes/grout/GroutQuoteCreated'
import UnderlaymentProductSelection from './productTypes/underlayment/UnderlaymentProductSelection'
import UnderlaymentCoverageDetails from './productTypes/underlayment/UnderlaymentCoverageDetails'
import UnderlaymentQuoteCreated from './productTypes/underlayment/UnderlaymentQuoteCreated'

export default function renderSwitch(thisStep) {
   switch(thisStep) {
   case 'productTypeSelection': return <ProductTypeSelection />
   case 'resinousApplicationSelection': return <ResinousApplicationSelection />
   case 'resinousSystemSelection': return <ResinousSystemSelection />
   case 'resinousSystemTypeSelection': return <ResinousSystemTypeSelection />
   case 'resinousCoverageDetails': return <ResinousCoverageDetails />
   case 'resinousCoveCoverageDetails': return <ResinousCoveCoverageDetails />
   case 'resinousQuoteCreated': return <ResinousQuoteCreated />
   case 'resinousCoveQuoteCreated': return <ResinousCoveQuoteCreated />
   case 'adhesivesProductSelection': return <AdhesivesProductSelection />
   case 'adhesivesCoverageDetails': return <AdhesivesCoverageDetails />
   case 'adhesivesQuoteCreated': return <AdhesivesQuoteCreated />
   case 'groutProductSelection': return <GroutProductSelection />
   case 'groutCoverageDetails': return <GroutCoverageDetails />
   case 'groutQuoteCreated': return <GroutQuoteCreated />
   case 'underlaymentProductSelection': return <UnderlaymentProductSelection />
   case 'underlaymentCoverageDetails': return <UnderlaymentCoverageDetails />
   case 'underlaymentQuoteCreated': return <UnderlaymentQuoteCreated />
   default: return (alert("Step component not found in renderSwitch(thisStep)."))
   }
}


// WEBPACK FOOTER //
// ./src/components/renderSwitch.js